"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapRequireWithInlineModules = exports.transformationPlugins = exports.inlineModules = void 0;
var tslib_1 = require("tslib");
var consts_1 = require("../consts");
var wix_media_url_1 = tslib_1.__importStar(require("./wix-media-url"));
var wix_font_themes_1 = tslib_1.__importDefault(require("./wix-font-themes"));
var spxResolver_1 = tslib_1.__importDefault(require("./spxResolver"));
var hexAlpha_1 = tslib_1.__importDefault(require("./hexAlpha"));
var spxFixedResolver_1 = tslib_1.__importDefault(require("./spxFixedResolver"));
exports.inlineModules = Object.create(null); // we use create(null) so method that need to be exported to be used within stylable are not exposed (otherwise you could import toString for instance
exports.inlineModules[consts_1.wixMediaUrlName] = wix_media_url_1.default;
exports.inlineModules[consts_1.wixFontThemesName] = wix_font_themes_1.default;
exports.inlineModules[consts_1.wixSpxName] = spxResolver_1.default;
exports.inlineModules[consts_1.wixHexAlphaName] = hexAlpha_1.default;
exports.inlineModules[consts_1.wixSpxFixedName] = spxFixedResolver_1.default;
exports.transformationPlugins = [wix_media_url_1.wixMediaUrlTransformationPlugin];
function wrapRequireWithInlineModules(requireModule, modulesToInline) {
    return function (id) {
        var inlineModule = modulesToInline[id];
        return inlineModule ? inlineModule : requireModule(id);
    };
}
exports.wrapRequireWithInlineModules = wrapRequireWithInlineModules;
//# sourceMappingURL=inline-modules.js.map